import React from 'react';
import css from './OfferTn.module.scss';
import Tooltip from "@material-ui/core/Tooltip";
import react from "../../../assets/images/extra/react-native.png";
import python from "../../../assets/images/extra/python.png";
import django from "../../../assets/images/extra/icons8-django-50.png";
import postgres from "../../../assets/images/extra/postgreesql.png";
import github from "../../../assets/images/extra/github--v1.png";
import Chip from "@material-ui/core/Chip";
import offerTn from "../../../assets/images/projectsImage/offerTn.jpg";
import heroku from "../../../assets/images/extra/heroku.png";
// import hover from "../../../assets/images/chibi_anime/hover.png";

const OfferTn: React.FC = () => (
    <div className={css.projectContainer} id="offerTn">
        <div className={css.project}>
            <img src={offerTn} className={css.offerTnImg} alt=""/>
            <div className={css.projectInformationContainer}>
                <div className={css.projectName}>
                    <h3>Offer</h3>
                    <h3 style={{color: '#e31b6d'}}>.tn</h3>
                </div>
                <div className={css.info}>
                    <Chip label="Sept. 2020 - On Hold" size='small' variant="outlined"/>
                </div>
                <div className={css.infoSmallScreen}>
                    <Chip label="Sept. 2020 - On Hold" size='small' variant="outlined"/>
                </div>
                <h5 className={css.textSectionInfo}>Description:</h5>
                <p className={css.description}>
                    It's an Ecommerce application, that shows information about available products
                    country wide, track fake discount...
                </p>
                <div className={css.learnMoreLink}>
                    <div style={{display: 'flex', flexDirection: "row", flexFlow: "wrap"}}>
                        <p style={{marginRight: "0.5em"}}>Demo: <a className={css.link}
                                    href='https://offer-tn.herokuapp.com'
                                    rel="noopener noreferrer"
                                    target="_blank">https://offer-tn.herokuapp.com</a>
                        </p>
                        <p style={{display: 'flex', flexDirection: "row", alignItems: 'center'}}>
                            (<h5 style={{margin: "0 0.5em 0 0"}}>Note: </h5> wait 30 sec to wake up the instance)
                        </p>
                    </div>

                    <p>Source Code: <a className={css.link}
                                      href='https://github.com/adhess?tab=repositories&q=offer-tn'
                                      rel="noopener noreferrer"
                                      target="_blank">https://github.com/adhess?tab=repositories&q=offer-tn</a>
                    </p>
                </div>
                <h5 className={css.textSectionInfo}>Keywords:</h5>
                <div className={css.keywords}>
                    <Tooltip title="ReactJs">
                        <img src={react} alt=""/>
                    </Tooltip>
                    <Tooltip title="Python">
                        <img src={python} alt=""/>
                    </Tooltip>
                    <Tooltip title="Django">
                        <img src={django}
                             style={{width: 48, height: 48}} alt=""/>
                    </Tooltip>
                    <Tooltip title="PostgreeSQL">
                        <img src={postgres} alt=""/>
                    </Tooltip>
                    <Tooltip title="Github">
                        <img src={github} alt=""/>
                    </Tooltip>
                    <Tooltip title="Heroku">
                        <img src={heroku} alt=""/>
                    </Tooltip>
                </div>
            </div>
        </div>
    </div>

);

export default OfferTn;
